/// <reference lib="dom" />
import { BaseAuthenticator } from './base-authenticator.js';
import { appendHeaders } from './helpers.js';
export class FusionAuthenticator extends BaseAuthenticator {
    constructor() {
        super('fusion');
    }
    authenticate() {
        var _a, _b, _c, _d, _e, _f;
        const hasUser = !!((_b = (_a = window.prism) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b._id);
        this._resolve(hasUser);
        const antiCsrfToken = (_e = (_d = (_c = window.document) === null || _c === void 0 ? void 0 : _c.cookie) === null || _d === void 0 ? void 0 : _d.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)) === null || _e === void 0 ? void 0 : _e[1];
        if (antiCsrfToken)
            this.antiCsrfToken = antiCsrfToken;
        try {
            const environment = (_f = window.prism) === null || _f === void 0 ? void 0 : _f.$injector.get('$component').getParentEventTarget().getEnvironment();
            if (environment === null || environment === void 0 ? void 0 : environment.isTokenBasedAuth_()) {
                this.wat = environment.getWebSessionToken();
                this.watInitialiser = environment.getHashedWebAccessToken();
            }
        }
        catch (e) {
            // Silently ignore errors if the environment is not available
        }
        return this._result;
    }
    applyHeaders(headers) {
        if (this.antiCsrfToken) {
            appendHeaders(headers, {
                'X-Xsrf-Token': this.antiCsrfToken,
            });
        }
        if (this.wat && this.watInitialiser) {
            appendHeaders(headers, {
                Authorization: this.wat,
                Initialiser: this.watInitialiser,
            });
        }
    }
}
/**
 * Checks if the authenticator is SSO authenticator
 *
 * @param authenticator - authenticator to check
 * @internal
 */
export function isFusionAuthenticator(authenticator) {
    return authenticator.type === 'fusion';
}
//# sourceMappingURL=fusion-authenticator.js.map